import React from 'react'
import { Box, SimpleGrid } from '@chakra-ui/react'
import Link from 'next/link'
import Image from 'next/image'
import RouterUrl from '@constants/router.constant'

interface PropsType {
  brands: any[]
}

export const BrandItem = ({ brand }: { brand: any }) => {
  const brandHandle: string = brand.handle ?? ''
  return (
    <Box
      h={'160px'}
      w={'100%'}
      alignItems="center"
      justifyContent={'center !important'}
      display={'flex'}
      data-aos="fade-up"
    >
      <Link href={`${RouterUrl.BRAND.ROOT}/${brandHandle}`} passHref>
        <Image
          src={brand?.logo ?? ''}
          alt={brand?.title ?? 'logo brand'}
          width={150}
          height={100}
          quality={100}
        />
      </Link>
    </Box>
  )
}

const ListBrands = ({ brands }: PropsType) => {
  const displayBrands = () => {
    if (brands.length) {
      return brands.map((b) => {
        return <BrandItem key={b.id} brand={b} />
      })
    }
  }

  return (
    <SimpleGrid
      templateColumns={{
        sm: '1fr 1fr',
        md: '6fr 6fr',
        lg: '3fr 3fr 3fr',
        xl: '4fr 4fr 4fr 4fr'
      }}
      spacing={5}
      w={'100%'}
    >
      {displayBrands()}
    </SimpleGrid>
  )
}

export default ListBrands
